import React, { useEffect, useState } from "react";
import { BsFillFilterCircleFill } from "react-icons/bs";
import "./AvatarComponent.scss";

const colors = [
  "#1abc9c", // A-G - Turquoise
  "#3498db", // H-N - Blue
  "#9b59b6", // O-U - Amethyst
  "#e67e22", // V-Z - Carrot
  "#f1c40f",
];

// Function to assign color based on the initial letter
function getColorForName(name) {
  if (name.toLowerCase().includes("pras")) return colors[4];
  const firstLetter = name[0].toUpperCase(); // Get the first letter and convert to uppercase
  if (firstLetter >= "A" && firstLetter <= "G") return colors[0];
  if (firstLetter >= "H" && firstLetter <= "N") return colors[1];
  if (firstLetter >= "O" && firstLetter <= "U") return colors[2];
  if (firstLetter >= "V" && firstLetter <= "Z") return colors[3];
}

const AvatarComponent = ({
  imgSrc,
  fullName,
  handleselectedIds = () => {},
  id,
  clickble = true,
  selectedUserIds = [],
  hover = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Assign color based on name
  const [fallbackBackgroundColor, setFallbackBackgroundColor] = useState(getColorForName(fullName));

  useEffect(() => {
    if (imageError) {
      setFallbackBackgroundColor(getColorForName(fullName)); // Recalculate color if there is an image error
    }
  }, [imageError, fullName]);

  const handleError = () => {
    setImageError(true);
  };

  useEffect(() => {
    if (selectedUserIds.length > 0) {
      const buttonClicked = selectedUserIds.includes(id);
      setIsClicked(buttonClicked);
    }
  }, [selectedUserIds, id]);

  const handleClick = (id) => {
    setIsClicked(!isClicked);
    handleselectedIds(id);
  };

  // Function to get initials based on the full name
  const getInitials = (name) => {
    const names = name.split(" ");
    if (names.length > 1) {
      return `${names[0].charAt(0)}${names[1].charAt(0)}`; // Two letters from two words
    }
    return names[0].charAt(0); // One letter from one word
  };

  return (
    <div
      className={`avatar-container ${isClicked && clickble ? "clicked" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={clickble ? () => handleClick(id) : () => {}}
    >
      {!imageError ? (
        <img src={imgSrc} alt={fullName} className="avatar-img" onError={handleError} />
      ) : (
        <div className="avatar-fallback" style={{ backgroundColor: fallbackBackgroundColor }}>
          {getInitials(fullName)?.toUpperCase()}
        </div>
      )}
      {isHovered && hover && (
        <div className="tooltip">
          <div className="hover-info">
            <p>{fullName}</p>
          </div>
        </div>
      )}
      {isClicked && clickble && (
        <div className="icon-overlay">
          <BsFillFilterCircleFill className="filter-icon" />
        </div>
      )}
    </div>
  );
};

export default AvatarComponent;
